<template>
    <div>
        <modal class="reset-pwd" :display="modalStatus.resetPwd" @modalStatus="closeModal" >
            <alarm-msg-white type="SUCCESS" :msg="alarm.success.msg" :count="alarm.success.count" :showAlarm="alarm.success.status" @timeOut="alarm.success.status=false"></alarm-msg-white>
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>重新設定密碼</h1>
            <div class="reset-pwd-wrap">
                <div class="description">
                    輸入登入使用的信箱，系統將會發送一封密碼重設定信件，幫助您重新設定您的密碼！
                </div>
                <div class="account">
                    <label for="account" class="button-font input-label">
                        <span></span>
                        <span v-show="error.reset.account" class="error-with-title">{{error.reset.account}}</span>
                    </label>
                    <div class="input-error-group">
                        <input class="landing-input" :class="{error: error.reset.account}" type="text" v-model="reset.account" placeholder="請輸入您登入時的信箱">
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="landing-default-btn confirm" :disabled="status.isDisable" @click="resetPwdEmail()">
                        寄送重設密碼信件
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import { mapGetters } from 'vuex'
import { apiBizResetPwdEmail } from "@/apis/api.js"; 

export default {
    data () {
        return {
            reset: {
                account: null
            },
            error: {
                reset: {
                    account: null
                }
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 2000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 2000
                }
            },
            status: {
                isDisable: false,
            }
        }
    },
    watch: {
        'reset.account': function (val) {
            console.log(val)
            let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
            
            if( val.length > 0 ){
                if (!isMail.test(val)) {
                    this.error.reset.account = '電子郵件格式錯誤';
                }else {
                    this.error.reset.account = null;
                }
            }else{
                this.error.reset.account = null;
            }
        }
    },
    methods: {
        resetPwdEmail: function () {
            if(this.checkInput()){
                let email = this.reset.account
                let data = {email}

                this.status.isDisable = true 

                apiBizResetPwdEmail(data)
                .then(res => {
                    console.log(res)
                    this.status.isDisable = false 
                    if( res.data.status == "SUCCESS" ){
                        this.alarm.success.msg = '密碼重置函已寄出，請前往信箱收信，並完成後續動作'
                        this.alarm.success.status = true
                    }else{
                        this.alarm.error.msg = res.data.errorMsg
                        this.alarm.error.status = true
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.status.isDisable = false 
                    this.alarm.error.msg = '系統發生未預期錯誤，請再試一次'
                    this.alarm.error.status = true
                })
            }
            
        },
        checkInput: function () {
            if(!this.reset.account){
                this.error.reset.account = '請輸入電子郵件'
            }
            if(
                this.reset.account &&
                this.error.reset.account == null
            ){
                return true
            }else{
                return false
            }
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'resetPwd'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        alarmMsgWhite,
        btnLoading
    }
}
</script>
<style lang="scss"  >
    #modal.reset-pwd{
        .modal-content{
            width: 368px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    text-align: center;
                    font-size: 24px;
                    font-weight: 500;
                    margin: 32px auto 24px;
                    line-height: 1.5;
                }
                .reset-pwd-wrap{
                    width: 308px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    margin: 0 auto;
                    .description{
                        width: 286px;
                        text-align: center;
                        line-height: 1.71;
                        margin-bottom: 3px;
                    }
                    .account{
                        width: 308px;
                        margin-bottom: 24px;
                        label{
                            height: 16px;
                        }
                        input{
                            width: 100%;
                            box-sizing: border-box;
                        }
                        
                    }
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    margin: 0 auto;
                    button{
                        width: 308px;
                        margin-bottom: 0px;
                        
                    }
                    .loading-wrap{
                        position: relative;
                        .btn-loading{
                            left: 64px;
                            top: 6px;
                        }
                    }
                }
            }
      
        }
    }
    @media screen and (max-width: 375px) {
        #modal.reset-pwd{
            .modal-content{
                width: 340px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/resetPwd.vue